<template lang="pug">
v-dialog(
  scrollable lazy
  v-model='dialog'
  max-width='500px'
)
  v-card
    //- 表單
    v-card-text(v-if='data')
      v-form(v-model='valid')
        v-textarea(:label='$t("quesiton")' :rules='rules' v-model.trim='data.question' autofocus)
        v-textarea(:label='$t("answer")' :rules='rules' v-model.trim='data.answer')

    v-divider

    //- 工具列
    v-card-actions
      v-spacer
      v-btn(flat @click='close') {{ $t('cancel') }}
      v-btn.primary--text(flat @click='save' :disabled='!valid') {{ $t('save') }}
</template>

<script>
import { formStatus } from '@/mixins/formStatus'
import Loader from '@/components/Loader.vue'

export default {
  name: 'EditQa',
  data () {
    this.rules = [v => !!v || this.$t('fieldIsRequired')]
    return {
      valid: true,
      index: null,
      data: null,
    }
  },
  methods: {
    edit (data, index) {
      const randomString = require('random-base64-string')

      this.data = null
      this.dialog = true
      this.index = index

      this.$nextTick(() => {
        this.data = (index === undefined)
          ? { question: '', answer: '', _id: randomString(6) } // 新增的空物件
          : { ...data } // 拷貝原物件
      })
    },
    save () {
      this.$emit('done', { ...this.data }, this.index)
      this.dialog = false
    },
  },
  components: {
    Loader,
  },
  mixins: [formStatus],
}
</script>

<i18n src="@/lang/components/qa/editQa.json"></i18n>
